var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[[_c('Navbar')],_c('div',{staticClass:"main_container"},[_c('router-view'),_c('loader')],1),_c('Footer')],2)}
var staticRenderFns = []

export { render, staticRenderFns }